/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { MenuProps } from './type';
import MenuItem from '../MenuItem';

const Menu = (props: MenuProps): JSX.Element => {
  const { data, leftIcon, rightIcon } = props;

  return (
    <div id="sidebar-menu">
      <ul className="side-menu">
        {data.map((v) => (
          <MenuItem
            key={v.url}
            leftIcon={leftIcon}
            rightIcon={rightIcon}
            data={v}
            style={v.style}
          />
        ))}
      </ul>
    </div>
  );
};

export default Menu;
